import { useMemo } from 'react'
import { zeroPadding } from 'lib/helper'
import { SelectOption } from 'types/common'

const useLastPickupTimes = (lastOrderTime: string, orderStartTime: string): SelectOption[] => {
  return useMemo(() => {
    const _times: SelectOption[] = [{ label: '', value: '' }]
    const startHour = parseInt(lastOrderTime.split(':')[0], 10)
    let startTime = parseInt(lastOrderTime.split(':')[1], 10)

    // 15分毎で24時間分のリストを作る
    for (let i = startHour; i < 24; i = (i + 1) | 0) {
      for (let j = startTime; j < 60; j = (j + 15) | 0) {
        // 開始時刻をリセット
        if (startTime !== 0) startTime = 0

        const time = `${zeroPadding(i)}:${zeroPadding(j)}`
        _times.push({ label: time, value: time })
      }
    }

    return _times
  }, [lastOrderTime, orderStartTime])
}

export default useLastPickupTimes
